<div class="w-100">
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col mt-0">
                            <h5 class="card-title">New Bookings</h5>
                        </div>
                        <div class="col-auto">
                            <div class="col-green">
                                <i class="fas fa-user-friends pull-left card-icon col-orange font-30"></i>
                            </div>
                        </div>
                    </div>
                    <h1 class="mt-1 mb-3">456</h1>
                    <div class="mb-0">
                        <span class="text-success m-r-10"><i
                                class="material-icons col-green align-middle">trending_up</i>
                            10.32%
                        </span>
                        <span class="text-muted">Since last week</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6">

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col mt-0">
                            <h5 class="card-title">Revenue</h5>
                        </div>
                        <div class="col-auto">
                            <div class="col-green">
                                <i class="fas fa-dollar-sign pull-left card-icon font-30"></i>
                            </div>
                        </div>
                    </div>
                    <h1 class="mt-1 mb-3">$2,352</h1>
                    <div class="mb-0">
                        <span class="text-danger m-r-10"><i
                                class="material-icons col-red align-middle">trending_down</i>
                            -4.27%
                        </span>
                        <span class="text-muted">Since last week</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col mt-0">
                            <h5 class="card-title">Total Sessions</h5>
                        </div>
                        <div class="col-auto">
                            <div class="col-green">
                                <i class="fas fa-user-friends pull-left card-icon col-orange font-30"></i>
                            </div>
                        </div>
                    </div>
                    <h1 class="mt-1 mb-3">456</h1>
                    <div class="mb-0">
                        <span class="text-success m-r-10"><i
                                class="material-icons col-green align-middle">trending_up</i>
                            10.32%
                        </span>
                        <span class="text-muted">Since last week</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col mt-0">
                            <h5 class="card-title">Subscribers</h5>
                        </div>
                        <div class="col-auto">
                            <div class="col-green">
                                <i class="fas fa-user-friends pull-left card-icon col-orange font-30"></i>
                            </div>
                        </div>
                    </div>
                    <h1 class="mt-1 mb-3">456</h1>
                    <div class="mb-0">
                        <span class="text-success m-r-10"><i
                                class="material-icons col-green align-middle">trending_up</i>
                            10.32%
                        </span>
                        <span class="text-muted">Since last week</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col mt-0">
                            <h5 class="card-title">Recurring %</h5>
                        </div>
                        <div class="col-auto">
                            <div class="col-green">
                                <i class="fas fa-user-friends pull-left card-icon col-orange font-30"></i>
                            </div>
                        </div>
                    </div>
                    <h1 class="mt-1 mb-3">456</h1>
                    <div class="mb-0">
                        <span class="text-success m-r-10"><i
                                class="material-icons col-green align-middle">trending_up</i>
                            10.32%
                        </span>
                        <span class="text-muted">Since last week</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>